export enum BioSampleRefType {
  VISIT_ID = 'VISIT_ID',
  ALIQUOT_PARENT_ID = 'ALIQUOT_PARENT_ID',
}
